import { setSupervisorRating, SkillRatingId } from '~/monolith-api';
import { useRegisteredMutation } from '~/queries';

export function useSetSupervisorRating(skillRatingId: SkillRatingId, teamid?: number) {
   return useRegisteredMutation('supervisor-rating', async (rating: number): Promise<null> => {
      return await setSupervisorRating(skillRatingId, rating, teamid);
   });
}
